var InputFormControl = /** @class */ (function () {
    function InputFormControl() {
    }
    Object.defineProperty(InputFormControl, "bindActions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (formControl, events) {
            return {
                ref: function (element) {
                    formControl.element = element;
                    if (!!events) {
                        events.ref && events.ref(element);
                    }
                },
                onChange: function (event) {
                    formControl.value = event.target.type === 'checkbox'
                      ? event.target.checked
                      : event.target.value;
                    if (!!events) {
                        events.onChange && events.onChange(event);
                    }
                },
                onBlur: function (event) {
                    formControl.setTouched(true);
                    formControl.setFocused(false);
                    if (!!events) {
                        events.onBlur && events.onBlur(event);
                    }
                },
                onFocus: function (event) {
                    formControl.setFocused(true);
                    if (!!events) {
                        events.onFocus && events.onFocus(event);
                    }
                },
            };
        }
    });
    return InputFormControl;
}());
export { InputFormControl };
var TextAreaFormControl = /** @class */ (function () {
    function TextAreaFormControl() {
    }
    Object.defineProperty(TextAreaFormControl, "bindActions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (formControl, events) {
            return {
                ref: function (element) {
                    formControl.element = element;
                    if (!!events) {
                        events.ref && events.ref(element);
                    }
                },
                onChange: function (event) {
                    formControl.value = event.target.value;
                    if (!!events) {
                        events.onChange && events.onChange(event);
                    }
                },
                onBlur: function (event) {
                    formControl.setTouched(true);
                    formControl.setFocused(false);
                    if (!!events) {
                        events.onBlur && events.onBlur(event);
                    }
                },
                onFocus: function (event) {
                    formControl.setFocused(true);
                    if (!!events) {
                        events.onFocus && events.onFocus(event);
                    }
                },
            };
        }
    });
    return TextAreaFormControl;
}());
export { TextAreaFormControl };
var SelectFormControl = /** @class */ (function () {
    function SelectFormControl() {
    }
    Object.defineProperty(SelectFormControl, "bindActions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (formControl, events) {
            return {
                ref: function (element) {
                    formControl.element = element;
                    if (!!events) {
                        events.ref && events.ref(element);
                    }
                },
                onChange: function (event) {
                    formControl.value = event.target.value;
                    if (!!events) {
                        events.onChange && events.onChange(event);
                    }
                },
                onBlur: function (event) {
                    formControl.setTouched(true);
                    formControl.setFocused(false);
                    if (!!events) {
                        events.onBlur && events.onBlur(event);
                    }
                },
                onFocus: function (event) {
                    formControl.setFocused(true);
                    if (!!events) {
                        events.onFocus && events.onFocus(event);
                    }
                },
            };
        }
    });
    return SelectFormControl;
}());
export { SelectFormControl };
//# sourceMappingURL=form-control-extensions.js.map